export default "__VITE_ASSET__BbXHVjTV__"